import React, { Suspense, useState, useRef } from "react";
import { Canvas } from "@react-three/fiber";
import { useProgress, PerformanceMonitor } from "@react-three/drei";
import { Leva } from "leva";
import { Perf } from "r3f-perf";
import hdr from "../../assets/images/Refine4.hdr";
import Lights from "./Car/CarFlip/Lights";
import CarAssembly from "./Car";
import Controls from "./Controls";
import { FileUploader } from "react-drag-drop-files";
import OrbitMode from "./Car/OrbitMode/OrbitMode";
import CameraTransitions from "./util/CameraTransitions";
import { isMobile } from "react-device-detect";
import useTransitionStore from "../../state/transitions";
import useCustomizerStore from "../../state/customizer";
import { defaultControlAngles } from "../../util/defaultControlAngles";
// import styled from "styled-components";
// import { AnimatePresence, motion } from "framer-motion";
// import Lottie from "react-lottie";
// import loadingAnimation from "../../assets/animations/loading.json";
import * as three from "three";
import Loading from "../../util/Loading";
import useFogControlStore from "../../state/fogControls";
import DayXrEnvironment from "./DayXrEnvironment";

export default React.memo(function Scene() {
  const [dpr, setDpr] = useState(2);
  const { progress } = useProgress();
  // const [showLoading, setShowLoading] = useState(true);
  const HotspotControls = useTransitionStore((s) => s.HotspotControls);
  const setHotspotControls = useTransitionStore((s) => s.setHotspotControls);
  const setCamIndex = useTransitionStore((s) => s.setCamIndex);
  const setAzimuthAndPolarAngles = useTransitionStore(
    (s) => s.setAzimuthAndPolarAngles
  );
  const setTriggerExitHotspot = useTransitionStore(
    (s) => s.setTriggerExitHotspot
  );
  const DayMode = useTransitionStore((s) => s.DayMode);
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const dayFog = useFogControlStore((state) => state.dayFog);
  const nightStudioFog = useFogControlStore((state) => state.nightStudioFog);
  const suspensionFog = useFogControlStore((state) => state.suspensionFog);
  const ShowInterior = useTransitionStore((s) => s.ShowInterior);
  const TriggerExitHotspot = useTransitionStore((s) => s.TriggerExitHotspot);
  const setHotspotZoomed = useTransitionStore((s) => s.setHotspotZoomed);
  const setSuspensionMode = useTransitionStore((s) => s.setSuspensionMode);
  const SuspensionMode = useTransitionStore((s) => s.SuspensionMode);
  const setSelectedHotspot = useCustomizerStore((s) => s.setSelectedHotspot);
  const setFutureSelectedHotspotDescription = useCustomizerStore(
    (s) => s.setFutureSelectedHotspotDescription
  );
  const setFutureSelectedHotspotTitle = useCustomizerStore(
    (s) => s.setFutureSelectedHotspotTitle
  );
  const setDisclaimerOpen = useCustomizerStore((s) => s.setDisclaimerOpen);
  const setSelectedDisclaimer = useCustomizerStore(
    (s) => s.setSelectedDisclaimer
  );
  const setFilterHotspots = useCustomizerStore((s) => s.setFilterHotspots);
  const filterHotspots = useCustomizerStore((s) => s.filterHotspots);
  const setfutureSelectedDisclaimer = useCustomizerStore(
    (s) => s.setfutureSelectedDisclaimer
  );

  const [file, setFile] = useState(hdr);
  const group = useRef(null);
  const showDayEnvironment =
    DayMode === "day" && DisplayMode !== "flipper" && !SuspensionMode;

  const convertFileToImage = (file) => {
    const reader = new FileReader();

    reader.addEventListener(
      "load",
      () => {
        setFile(reader.result);
      },
      false
    );

    reader.readAsDataURL(file);
  };

  // useEffect(() => {
  //   if (progress === 100) {
  //     setTimeout(() => {
  //       setShowLoading(false);
  //     }, 2000);
  //   }
  // }, [progress]);

  console.log(`scene`);

  return (
    <>
      <Leva hidden />
      {/* {isMobile ? <Leva hidden /> : <Leva collapsed />} */}
      {/* {!isMobile && (
        <div style={{ position: "absolute", zIndex: "999999", top: "100px" }}>
          <FileUploader
            handleChange={(file) => convertFileToImage(file)}
            name="file"
            types={["hdr"]}
          />
        </div>
      )} */}
      <Suspense fallback={<Loading />}>
        <Canvas
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0",
            overflow: "hidden",
            pointerEvents: "none",
          }}
          linear={ShowInterior}
          camera={{ far: 250, near: 0.5 }}
          onWheel={(e) => {
            if (!HotspotControls) return;
            setSelectedHotspot("");
            setDisclaimerOpen(false);
            setfutureSelectedDisclaimer("");
            // setSelectedDisclaimer("");
            setFutureSelectedHotspotDescription("");
            setFutureSelectedHotspotTitle("");
            setfutureSelectedDisclaimer("");
            setAzimuthAndPolarAngles(defaultControlAngles);
            setTriggerExitHotspot(!TriggerExitHotspot);
            setHotspotControls(false);
            setHotspotZoomed(false);
            if (filterHotspots) setFilterHotspots(false);
            if (SuspensionMode) {
              setSuspensionMode(false);
              setTriggerExitHotspot(!TriggerExitHotspot);
            }
          }}
          gl={{
            alpha: true,
            antialias: true,
          }}
          dpr={[1, 2]}
          // dpr={dpr}
          // performance={{ min: 0.5 }}
        >
          <color attach="background" args={["#000000"]} />
          {DayMode === "day" &&
          DisplayMode !== "flipper" &&
          !SuspensionMode &&
          dayFog.enabled ? (
            <fog attach="fog" args={[dayFog.color, dayFog.near, dayFog.far]} />
          ) : null}
          {(DayMode === "night" || DisplayMode === "flipper") &&
          !SuspensionMode &&
          nightStudioFog.enabled ? (
            <fog
              attach="fog"
              args={[
                nightStudioFog.color,
                nightStudioFog.near,
                nightStudioFog.far,
              ]}
            />
          ) : null}
          {SuspensionMode && suspensionFog.enabled ? (
            <fog
              attach="fog"
              args={[suspensionFog.color, suspensionFog.near, suspensionFog.far]}
            />
          ) : null}
          {/* <Perf position={"bottom-left"} /> */}
          {/* <PerformanceMonitor
          onChange={({ factor }) => setDpr(round(0.5 + 1.5 * factor, 1))}
        > */}
          {DisplayMode !== "flipper" && !showDayEnvironment && (
            <mesh scale={180} frustumCulled={false}>
              <sphereGeometry args={[1, 48, 48]} />
              <meshBasicMaterial color="#000000" side={three.BackSide} />
            </mesh>
          )}
          <DayXrEnvironment
            mode={showDayEnvironment ? "day" : "night"}
          />
          <group ref={group}>
            <group position={[0, -2.5, 0]}>
              <CarAssembly />
            </group>
            <OrbitMode />
            <Lights />
            <CameraTransitions />
          </group>
          <Controls />
          {/* </PerformanceMonitor> */}
        </Canvas>
      </Suspense>
      {/* <AnimatePresence>
        {showLoading && (
          <LoadingOccluder
            key="loading-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <Lottie
              width={70}
              height={70}
              options={{
                loop: true,
                autoplay: true,
                animationData: loadingAnimation,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
            />
          </LoadingOccluder>
        )}
      </AnimatePresence> */}
    </>
  );
});

// const LoadingOccluder = styled(motion.div)`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background: #000;
//   z-index: 9000;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   color: #fff;
//   pointer-events: none;
// `;
